import { render } from "./Report.vue?vue&type=template&id=59f89b34"
import script from "./Report.vue?vue&type=script&lang=ts"
export * from "./Report.vue?vue&type=script&lang=ts"

import "./Report.vue?vue&type=style&index=0&id=59f89b34&lang=less"
script.render = render

export default script